export default "__VITE_ASSET__DEK7ASw2__"